// extracted by mini-css-extract-plugin
module.exports = {"parchment":"Parchment_parchment__2EL3o"};